var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 8, 8 m -8, 0 a 8,8 0 1,0 16,0 a 8,8 0 1,0 -16,0 M7.13333 13V5.84583H8.85714V13H7.13333ZM8 4.83046C7.72698 4.83046 7.49206 4.74197 7.29524 4.56497C7.09841 4.38488 7 4.16907 7 3.91756C7 3.66294 7.09841 3.44714 7.29524 3.27014C7.49206 3.09005 7.72698 3 8 3C8.27619 3 8.51111 3.09005 8.70476 3.27014C8.90159 3.44714 9 3.66294 9 3.91756C9 4.16907 8.90159 4.38488 8.70476 4.56497C8.51111 4.74197 8.27619 4.83046 8 4.83046Z"}));
}

Info.defaultProps = {"viewBox":"0 0 16 16","fill":"currentColor","fillRule":"evenodd"};

module.exports = Info;

Info.default = Info;
